import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditCreateFormComponent, FormConfig } from '@shared/components/edit-create-form';
import { TA_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';
import { TaApiService } from '@shared/services/ta-api.service';
import { ApiCallService } from '@shared/services/api-call.service';
import { DateHelper } from '@shared/helpers';

@Component({
  selector: 'ta-shift-time-absent-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule, EditCreateFormComponent],
  template: `
    <div class="p-3 w-full">

      <edit-create-form
        [editMode]="false"
        [initialData]="initialData"
        [formConfig]="formConfig"
        (formChange)="onFormChange($event)">
      </edit-create-form>

      <div class="mt-3 flex justify-end gap-2">
        <button pButton type="button" label="Hủy" class="p-button-text" (click)="onCancel()"></button>
        <button pButton type="button" label="Xác nhận" [severity]="'primary'"
                [disabled]="confirmDisabled" (click)="onConfirm()"></button>
      </div>
    </div>
  `
})
export class TaShiftTimeAbsentDialogComponent {
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);
  private taApi = inject(TaApiService);
  private apiCall = inject(ApiCallService);

  form: any = null;
  initialData: any = { cover: false };

  formConfig: FormConfig = {
    fields: [
      { key: 'note', label: 'Ghi chú', type: 'textarea', width: 'full', showDividerAfter: true },
      { key: 'cover', label: 'Có cover?', type: 'toggleSwitch', width: '1/3' },
      {
        key: 'coverTaId', label: 'TA', type: 'select', width: '2/3', required: true,
        config: { ...TA_SELECT_CONFIG, service: this.taApi },
        dependsOn: 'cover',
        disabled: (_e: boolean, v: any) => !v?.cover
      },
      {
        key: 'from', label: 'Từ', type: 'datepicker', width: '1/2',
        datePickerMode: 'time', dependsOn: 'cover',
        disabled: (_e: boolean, v: any) => !v?.cover
      },
      {
        key: 'to', label: 'Đến', type: 'datepicker', width: '1/2',
        datePickerMode: 'time', dependsOn: 'cover',
        disabled: (_e: boolean, v: any) => !v?.cover
      },
    ]
  };

  get confirmDisabled(): boolean {
    return !this.form?.valid
  }

  ngOnInit() {
    const original = (this.config?.data as any)?.original;
    // Keep the full original for copying
    this.initialData = { ...this.initialData, __original: original };
  }

  onFormChange(form: any) {
    this.form = form;
  }

  onCancel() {
    this.ref.close(false);
  }

  async onConfirm() {
    if (!this.form) return;
    const v = this.form.getRawValue();
    const orig = v.__original || (this.config?.data as any)?.original || {};

    const calls: any[] = [];
    // (1) mark absent
    calls.push(this.taApi.absentTaShiftTime(orig.id, { note: v?.note }));

    // (2) optional cover creation
    if (v.cover) {
      const from = v.from ? (v.from.getHours() * 60 + v.from.getMinutes()) : (orig.from?.getHours ? (orig.from.getHours() * 60 + orig.from.getMinutes()) : orig.from);
      const to = v.to ? (v.to.getHours() * 60 + v.to.getMinutes()) : (orig.to?.getHours ? (orig.to.getHours() * 60 + orig.to.getMinutes()) : orig.to);

      const dateStr = orig.date instanceof Date ? DateHelper.formatDateLocal(orig.date) : orig.date;

      calls.push(this.taApi.createTaShiftTime({
        taId: v.coverTaId,
        refId: orig.id,
        centerId: orig.studySpace ? null : orig.centerId,
        clusterId: orig.studySpace ? orig.clusterId : null,
        date: dateStr,
        from,
        to
      }));
    }

    const { results, hadThrown } = await this.apiCall.executeMany(calls, 'Đã đánh dấu nghỉ', { mode: 'batch' });
    const allOk = !hadThrown && results.every(r => r.success);
    if (allOk) {
      this.ref.close(true);
    }
  }
}

